import { observer } from 'mobx-react';
import { T, TPlainTextKey } from '../../../../../../../../../Translations';

interface Props {
  message: TPlainTextKey;
}

function ErrorMessage({ message }: Props) {
  return (
    <div className="text-red-500 text-sm mt-2">
      <T kind={message} />
    </div>
  );
}

export default observer(ErrorMessage);
